import {post} from '../../request'

/**
 * 订单列表
 * @param data
 * @returns {Promise<*>}
 */
export function getOrderManage(data) {
    return post("/admin/order/index", data)
}

/**
 * 订单详情
 * @param data
 * @returns {Promise<*>}
 */
 export function getDetails(data) {
    return post("/admin/order/details", data)
}


